/**
 * Created by katarinababic on 11.6.25.
 *
 * Fallback renderer for activity logs without pre-resolved properties.
 * Now uses pre-resolved display properties from entry when available.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { WeekDayEntryActivityLog } from '../../Model/Coach/Schedule/WeekDayEntryActivityLog';
import { useRootStore } from '../../Store/useRootStore';
import { WorkoutDayCardEventListItem } from './WorkoutDayCardEventListItem';
import { getMediaMediumOrSmallestUriObject } from '../../Model/Media/Media';

export type WorkoutDayCardLoggedActivityContainerProps = {
  entry: WeekDayEntryActivityLog;
};

export const WorkoutDayCardLoggedActivityContainer: React.FC<WorkoutDayCardLoggedActivityContainerProps> = observer(
  ({ entry }) => {
    const { analytics } = useRootStore();
    const navigate = useNavigate();

    // Use pre-resolved properties from entry (backend provides these)
    const { title, subtitle, media, showAsDone, activityLogId } = entry;

    const imageUri = media ? getMediaMediumOrSmallestUriObject(media).uri : undefined;
    const bgImage = imageUri ? `url(${imageUri})` : undefined;

    const handlePress = React.useCallback(() => {
      if (activityLogId) {
        analytics.logSelectContent('activityLog', activityLogId);
        navigate(`/activities/${activityLogId}`);
      }
    }, [activityLogId, analytics, navigate]);

    if (!title) {
      return null;
    }

    return (
      <WorkoutDayCardEventListItem
        title={title}
        subtitle={subtitle || ''}
        imageSource={bgImage}
        showAsDone={showAsDone}
        onPress={handlePress}
      />
    );
  },
);
